import { TranslateService } from "@ngx-translate/core";
import { TokenService } from "../token/token.service";
import { Injectable } from "@angular/core";
import { ContentUnMemberSettingDetail } from "src/app/models/shared/content-management/theme-setting.interface";
import { SupportedLanguageConstant } from "../../constants/common-constant";

@Injectable({
    providedIn: 'root'
})

export class MemberThemeService {
    noImageUrl: string = 'https://devwl000api01storage.blob.core.windows.net/assets/back-office/no-image.jpg';
    imageUrlPrefix: string = 'https://devwl000api01storage.blob.core.windows.net/assets/unlimited-member';
    constructor() { }

    public getTheme() {
        const lightTheme = { color1: '#75e8f0', color2: '#404041', color3: '#5e5e5e', color4: '#b1b3b5', color5: '#ffffff' };
        const darkTheme = { color1: '#75e8f0', color2: '#404041', color3: '#ffffff', color4: '#b1b3b5', color5: '#212121' };

        const themeObj = {
            color1: {
                section: 'Color1',
                light: {
                    fieldValue: lightTheme.color1,
                    fieldCss: '--wl-color-1',
                },
                dark: {
                    fieldValue: darkTheme.color1,
                    fieldCss: '--wl-color-1',
                },
                status: 1,
                isDeleted: false,
                sequence: 0,
                fieldKey: 'ColorCode'
            },
            color2: {
                section: 'Color2',
                light: {
                    fieldValue: lightTheme.color2,
                    fieldCss: '--wl-color-2',
                },
                dark: {
                    fieldValue: darkTheme.color2,
                    fieldCss: '--wl-color-2',
                },
                status: 1,
                isDeleted: false,
                sequence: 0,
                fieldKey: 'ColorCode'
            },
            color3: {
                section: 'Color3',
                light: {
                    fieldValue: lightTheme.color3,
                    fieldCss: '--wl-color-3',
                },
                dark: {
                    fieldValue: darkTheme.color3,
                    fieldCss: '--wl-color-3',
                },
                status: 1,
                isDeleted: false,
                sequence: 0,
                fieldKey: 'ColorCode'
            },
            color4: {
                section: 'Color4',
                light: {
                    fieldValue: lightTheme.color4,
                    fieldCss: '--wl-color-4',
                },
                dark: {
                    fieldValue: darkTheme.color4,
                    fieldCss: '--wl-color-4',
                },
                status: 1,
                isDeleted: false,
                sequence: 0,
                fieldKey: 'ColorCode'
            },
            color5: {
                section: 'Color5',
                light: {
                    fieldValue: lightTheme.color5,
                    fieldCss: '--wl-color-5',
                },
                dark: {
                    fieldValue: darkTheme.color5,
                    fieldCss: '--wl-color-5',
                },
                status: 1,
                isDeleted: false,
                sequence: 0,
                fieldKey: 'ColorCode'
            },
        };
        return themeObj;
    }

    public getGameNavigation() {
        const light = {
            slot: {
                fieldValue: this.imageUrlPrefix + '/game-tab/slot-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/slot-light-active.png',
            },
            live: {
                fieldValue: this.imageUrlPrefix + '/game-tab/live-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/live-light-active.png',
            },
            sport: {
                fieldValue: this.imageUrlPrefix + '/game-tab/sport-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/sport-light-active.png',
            },
            esport: {
                fieldValue: this.imageUrlPrefix + '/game-tab/esport-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/esport-light-active.png',
            },
            lottery: {
                fieldValue: this.imageUrlPrefix + '/game-tab/lottery-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/lottery-light-active.png',
            },
            fish: {
                fieldValue: this.imageUrlPrefix + '/game-tab/fish-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/fish-light-active.png',
            },
            p2p: {
                fieldValue: this.imageUrlPrefix + '/game-tab/p2p-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/p2p-light-active.png',
            },
            other: {
                fieldValue: this.imageUrlPrefix + '/game-tab/other-light.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/other-light-active.png',
            },
        };
        const dark = {
            slot: {
                fieldValue: this.imageUrlPrefix + '/game-tab/slot-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/slot-dark-active.png',
            },
            live: {
                fieldValue: this.imageUrlPrefix + '/game-tab/live-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/live-dark-active.png',
            },
            sport: {
                fieldValue: this.imageUrlPrefix + '/game-tab/sport-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/sport-dark-active.png',
            },
            esport: {
                fieldValue: this.imageUrlPrefix + '/game-tab/esport-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/esport-dark-active.png',
            },
            lottery: {
                fieldValue: this.imageUrlPrefix + '/game-tab/lottery-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/lottery-dark-active.png',
            },
            fish: {
                fieldValue: this.imageUrlPrefix + '/game-tab/fish-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/fish-dark-active.png',
            },
            p2p: {
                fieldValue: this.imageUrlPrefix + '/game-tab/p2p-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/p2p-dark-active.png',
            },
            other: {
                fieldValue: this.imageUrlPrefix + '/game-tab/other-dark.png',
                fieldValue2: this.imageUrlPrefix + '/game-tab/other-dark-active.png',
            },
        };

        const gameNavigationObj = {
            live: {
                section: 'Live',
                sequence: 1,
                light: {
                    fieldValue: light.live.fieldValue,
                    fieldCss: '--wl-game-tab-live',
                    fieldValue2: light.live.fieldValue2,
                    fieldCss2: '--wl-game-tab-live-active',
                },
                dark: {
                    fieldValue: dark.live.fieldValue,
                    fieldCss: '--wl-game-tab-live',
                    fieldValue2: dark.live.fieldValue2,
                    fieldCss2: '--wl-game-tab-live-active',
                },
                status: 1
            },
            slot: {
                section: 'Slot',
                sequence: 2,
                light: {
                    fieldValue: light.slot.fieldValue,
                    fieldCss: '--wl-game-tab-slot',
                    fieldValue2: light.slot.fieldValue2,
                    fieldCss2: '--wl-game-tab-slot-active',
                },
                dark: {
                    fieldValue: dark.slot.fieldValue,
                    fieldCss: '--wl-game-tab-slot',
                    fieldValue2: dark.slot.fieldValue2,
                    fieldCss2: '--wl-game-tab-slot-active',
                },
                status: 1
            },
            sport: {
                section: 'Sport',
                sequence: 3,
                light: {
                    fieldValue: light.sport.fieldValue,
                    fieldCss: '--wl-game-tab-sport',
                    fieldValue2: light.sport.fieldValue2,
                    fieldCss2: '--wl-game-tab-sport-active',
                },
                dark: {
                    fieldValue: dark.sport.fieldValue,
                    fieldCss: '--wl-game-tab-sport',
                    fieldValue2: dark.sport.fieldValue2,
                    fieldCss2: '--wl-game-tab-sport-active',
                },
                status: 1
            },
            esport: {
                section: 'ESport',
                sequence: 4,
                light: {
                    fieldValue: light.esport.fieldValue,
                    fieldCss: '--wl-game-tab-esport',
                    fieldValue2: light.esport.fieldValue2,
                    fieldCss2: '--wl-game-tab-esport-active',
                },
                dark: {
                    fieldValue: dark.esport.fieldValue,
                    fieldCss: '--wl-game-tab-esport',
                    fieldValue2: dark.esport.fieldValue2,
                    fieldCss2: '--wl-game-tab-esport-active',
                },
                status: 1
            },
            lottery: {
                section: 'Lotto',
                sequence: 5,
                light: {
                    fieldValue: light.lottery.fieldValue,
                    fieldCss: '--wl-game-tab-lottery',
                    fieldValue2: light.lottery.fieldValue2,
                    fieldCss2: '--wl-game-tab-lottery-active',
                },
                dark: {
                    fieldValue: dark.lottery.fieldValue,
                    fieldCss: '--wl-game-tab-lottery',
                    fieldValue2: dark.lottery.fieldValue2,
                    fieldCss2: '--wl-game-tab-lottery-active',
                },
                status: 1
            },
            fish: {
                section: 'Fish',
                sequence: 6,
                light: {
                    fieldValue: light.fish.fieldValue,
                    fieldValue2: light.fish.fieldValue2,
                },
                dark: {
                    fieldValue: dark.fish.fieldValue,
                    fieldCss: '--wl-game-tab-fish',
                    fieldValue2: dark.fish.fieldValue2,
                    fieldCss2: '--wl-game-tab-fish-active',
                },
                status: 1
            },
            p2p: {
                section: 'P2P',
                sequence: 7,
                light: {
                    fieldValue: light.p2p.fieldValue,
                    fieldCss: '--wl-game-tab-p2p',
                    fieldValue2: light.p2p.fieldValue2,
                    fieldCss2: '--wl-game-tab-p2p-active',
                },
                dark: {
                    fieldValue: dark.p2p.fieldValue,
                    fieldCss: '--wl-game-tab-p2p',
                    fieldValue2: dark.p2p.fieldValue2,
                    fieldCss2: '--wl-game-tab-p2p-active',
                },
                status: 1
            },
            other: {
                section: 'Other',
                sequence: 8,
                light: {
                    fieldValue: light.other.fieldValue,
                    fieldCss: '--wl-game-tab-other',
                    fieldValue2: light.other.fieldValue2,
                    fieldCss2: '--wl-game-tab-other-active',
                },
                dark: {
                    fieldValue: dark.other.fieldValue,
                    fieldCss: '--wl-game-tab-other',
                    fieldValue2: dark.other.fieldValue2,
                    fieldCss2: '--wl-game-tab-other-active',
                },
                status: 1
            },
        }

        return gameNavigationObj;
    }

    public getLogo() {
        const lightLogo = {
            header: {
                imageUrl: this.imageUrlPrefix + '/logo/header-logo-light.png'
            },
            sidebar: {
                imageUrl: this.imageUrlPrefix + '/logo/sidebar-logo-light.png'
            },
            // favicon: {
            //     imageUrl: this.imageUrlPrefix + '/logo/favicon-light.png'
            // }
        }
        const darkLogo = {
            header: {
                imageUrl: this.imageUrlPrefix + '/logo/header-logo-dark.png'
            },
            sidebar: {
                imageUrl: this.imageUrlPrefix + '/logo/sidebar-logo-dark.png'
            },
            // favicon: {
            //     imageUrl: this.imageUrlPrefix + '/logo/favicon-dark.png'
            // }
        }

        const logoObj = {
            header: {
                section: 'Header',
                light: {
                    fieldValue: lightLogo.header.imageUrl,
                    fieldCss: '--wl-header-logo',
                },
                dark: {
                    fieldValue: darkLogo.header.imageUrl,
                    fieldCss: '--wl-header-logo',
                },
                fieldKey: 'Image',
                status: 1,
                isDeleted: false,
                sequence: 0
            },
            sidebar: {
                section: 'Sidebar',
                light: {
                    fieldValue: lightLogo.sidebar.imageUrl,
                    fieldCss: '--wl-sidebar-logo',
                },
                dark: {
                    fieldValue: darkLogo.sidebar.imageUrl,
                    fieldCss: '--wl-sidebar-logo',
                },
                fieldKey: 'Image',
                status: 1,
                isDeleted: false,
                sequence: 0
            },
            // favicon: {
            //     section: 'Favicon',
            //     light: {
            //         fieldValue: lightLogo.favicon.imageUrl,
            //         fieldCss: '--wl-favicon-logo',
            //     },
            //     dark: {
            //         fieldValue: darkLogo.favicon.imageUrl,
            //         fieldCss: '--wl-favicon-logo',
            //     },
            //     fieldKey: 'Image',
            //     status: 1,
            //     isDeleted: false,
            //     sequence: 0
            // },
        }

        return logoObj;
    }

    public getFooterCertificate() {
        const certificate = {
            image: {
                light: {
                    fieldValue: `${this.imageUrlPrefix}/footer/certificate-light.png`,
                    fieldCss: '--wl-footer-certificate-img',
                },
                dark: {
                    fieldValue: `${this.imageUrlPrefix}/footer/certificate-dark.png`,
                    fieldCss: '--wl-footer-certificate-img',
                },
                status: 1,
                sequence: 0,
                isDeleted: false,
                fieldKey: 'Image',
                fieldType: 'Default',
                section: 'Image',
                category: 'FooterCertificate',
            }
        }

        return certificate;
    }

    public getFooterSecurity() {
        const security = {
            image: {
                light: {
                    fieldValue: `${this.imageUrlPrefix}/footer/security-light.png`,
                    fieldCss: '--wl-footer-security-img',
                },
                dark: {
                    fieldValue: `${this.imageUrlPrefix}/footer/security-dark.png`,
                    fieldCss: '--wl-footer-security-img',
                },
                status: 1,
                sequence: 0,
                isDeleted: false,
                fieldKey: 'Image',
                fieldType: 'Default',
                section: 'Image',
                category: 'FooterSecurity',
            }
        }

        return security;
    }

    public getFooterGamingLicense() {
        const gamingLicense = {
            image: {
                light: {
                    fieldValue: `${this.imageUrlPrefix}/footer/gaming-license-light.png`,
                    fieldCss: '--wl-footer-gaming-license-img',
                },
                dark: {
                    fieldValue: `${this.imageUrlPrefix}/footer/gaming-license-dark.png`,
                    fieldCss: '--wl-footer-gaming-license-img',
                },
                status: 1,
                sequence: 0,
                isDeleted: false,
                fieldKey: 'Image',
                fieldType: 'Default',
                section: 'Image',
                category: 'FooterGamingLicense',
            }
        }

        return gamingLicense;
    }

    public getFooterLegalDisclaimer() {
        const supportedLanguages = SupportedLanguageConstant;
        const getDisclaimer = (lang: string): string => {
            switch (lang) {
                case 'zh-CN':
                    return '本网站提供具有风险的游戏体验。使用本网站的用户必须年满18岁。我们不对您违反当地法律或法规的行为负责。';
                case 'zh-TW':
                    return '本網站提供具有風險的遊戲體驗。使用本網站的用戶必須年滿18歲。我們不對您違反當地法律或法規的行為負責。';
                case 'ms-MY':
                    return 'Laman web ini menawarkan pengalaman permainan yang melibatkan risiko. Untuk menggunakan laman kami, anda mesti berumur lebih dari 18 tahun. Kami tidak bertanggungjawab ke atas sebarang pelanggaran undang-undang atau peraturan tempatan anda.';
                case 'id-ID':
                    return 'Situs ini menawarkan pengalaman bermain yang mengandung risiko. Untuk menggunakan situs kami, Anda harus berusia di atas 18 tahun. Kami tidak bertanggung jawab atas pelanggaran hukum atau peraturan lokal Anda.';
                case 'th-TH':
                    return 'เว็บไซต์นี้ให้บริการประสบการณ์การเล่นเกมที่มีความเสี่ยง ในการใช้งานเว็บไซต์ของเรา คุณต้องมีอายุมากกว่า 18 ปี เราจะไม่รับผิดชอบต่อการละเมิดกฎหมายหรือข้อบังคับท้องถิ่นของคุณ';
                case 'vi-VN':
                    return 'Trang web cung cấp trải nghiệm chơi game có yếu tố rủi ro. Để sử dụng trang web của chúng tôi, bạn phải trên 18 tuổi. Chúng tôi không chịu trách nhiệm về bất kỳ hành vi vi phạm pháp luật hoặc quy định địa phương nào của bạn.';
                default:
                    return 'The website offers a gaming experience that involves risk. To use our site, you must be over 18 years old. We are not responsible for any violation of your local laws or regulations.';
            }
        };

        const disclaimerObject = supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = getDisclaimer(lang.code);
            return acc;
        }, {} as Record<string, string>);

        const legalDisclaimer = {
            image: {
                light: {
                    fieldValue: `${this.imageUrlPrefix}/footer/legal-disclaimer-light.png`,
                    fieldCss: '--wl-footer-legal-disclaimer-img',
                },
                dark: {
                    fieldValue: `${this.imageUrlPrefix}/footer/legal-disclaimer-dark.png`,
                    fieldCss: '--wl-footer-legal-disclaimer-img',
                },
                status: 1,
                sequence: 0,
                isDeleted: false,
                fieldKey: 'Image',
                fieldType: 'Default',
                section: 'Image',
                category: 'FooterSecurity',
            },
            description: {
                share: Object.entries(disclaimerObject).map(([key, value]) => ({
                    key,
                    value
                })),
                status: 1,
                sequence: 0,
                isDeleted: false,
                category: 'FooterSecurity',
                section: 'Description',
                fieldType: 'Default',
                fieldKey: 'Description', // by language code
            }
        }

        return legalDisclaimer;
    }

    public getFooterAboutUs() {
        const supportedLanguages = SupportedLanguageConstant;
        const getTitle = (lang: string): string => {
            switch (lang) {
                case 'zh-CN':
                    return '值得信赖的平台提供商';
                case 'zh-TW':
                    return '值得信賴的平台提供商';
                case 'ms-MY':
                    return 'Penyedia Platform Dipercayai Anda';
                case 'id-ID':
                    return 'Penyedia Platform Tepercaya Anda';
                case 'th-TH':
                    return 'ผู้ให้บริการแพลตฟอร์มที่คุณไว้วางใจ';
                case 'vi-VN':
                    return 'Nhà cung cấp nền tảng đáng tin cậy của bạn';
                default:
                    return 'Your Trusted Platform Provider';
            }
        };

        const getDescription = (lang: string): string => {
            switch (lang) {
                case 'zh-CN':
                    return '我们提供定制白标平台，助力企业通过可扩展、安全的系统实现增长和成功。';
                case 'zh-TW':
                    return '我們提供客製化白標平台，協助企業透過安全、可擴展系統實現成長與成功。';
                case 'ms-MY':
                    return 'Kami sediakan platform label putih yang boleh disesuaikan untuk menyokong pertumbuhan perniagaan anda.';
                case 'id-ID':
                    return 'Kami menyediakan platform label putih yang aman dan fleksibel untuk mendukung pertumbuhan bisnis Anda.';
                case 'th-TH':
                    return 'เราให้บริการแพลตฟอร์มฉลากขาวที่ปลอดภัยและปรับแต่งได้ เพื่อสนับสนุนธุรกิจของคุณเติบโต.';
                case 'vi-VN':
                    return 'Chúng tôi cung cấp nền tảng nhãn trắng an toàn, linh hoạt giúp doanh nghiệp phát triển.';
                default:
                    return 'We deliver secure, scalable white-label platforms to support your business growth.';
            }
        };


        const titleObject = supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = getTitle(lang.code);
            return acc;
        }, {} as Record<string, string>);

        const descObject = supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = getDescription(lang.code);
            return acc;
        }, {} as Record<string, string>);

        const aboutUs = {
            title: {
                share: Object.entries(titleObject).map(([key, value]) => ({
                    key,
                    value
                })),
                status: 1,
                sequence: 0,
                isDeleted: false,
                category: 'FooterSecurity',
                section: 'Title',
                fieldType: 'Default',
            },
            description: {
                share: Object.entries(descObject).map(([key, value]) => ({
                    key,
                    value
                })),
                status: 1,
                sequence: 0,
                isDeleted: false,
                category: 'FooterSecurity',
                section: 'Description',
                fieldType: 'Default',
            }
        }

        return aboutUs;
    }

    public getWalletOverview() {
        const lightWalletOverview = {
            deposit: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/deposit-light.png'
            },
            withdraw: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/withdraw-light.png'
            },
            restore: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/restore-light.png'
            },
            history: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/history-light.png'
            },
            message: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/message-light.png'
            },
        };

        const darkWalletOverview = {
            deposit: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/deposit-dark.png'
            },
            withdraw: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/withdraw-dark.png'
            },
            restore: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/restore-dark.png'
            },
            history: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/history-dark.png'
            },
            message: {
                fieldValue: this.imageUrlPrefix + '/wallet-overview/message-dark.png'
            },
        };

        const walletOverviewObj = {
            deposit: {
                status: 1,
                sequence: 1,
                image: {
                    section: 'Deposit',
                    light: {
                        fieldValue: darkWalletOverview.deposit.fieldValue,
                        fieldCss: '--wl-wallet-deposit-img',
                    },
                    dark: {
                        fieldValue: lightWalletOverview.deposit.fieldValue,
                        fieldCss: '--wl-wallet-deposit-img',
                    },
                    fieldKey: 'Image'
                }
            },
            withdraw: {
                sequence: 2,
                status: 1,
                image: {
                    section: 'Withdraw',
                    light: {
                        fieldValue: darkWalletOverview.withdraw.fieldValue,
                        fieldCss: '--wl-wallet-withdraw-img',
                    },
                    dark: {
                        fieldValue: lightWalletOverview.withdraw.fieldValue,
                        fieldCss: '--wl-wallet-withdraw-img',
                    },
                    fieldKey: 'Image'
                }
            },
            restore: {
                sequence: 3,
                status: 1,
                image: {
                    section: 'Restore',
                    light: {
                        fieldValue: darkWalletOverview.restore.fieldValue,
                        fieldCss: '--wl-wallet-restore-img',
                    },
                    dark: {
                        fieldValue: lightWalletOverview.restore.fieldValue,
                        fieldCss: '--wl-wallet-restore-img',
                    },
                    fieldKey: 'Image'
                },
            },
            history: {
                status: 1,
                sequence: 5,
                image: {
                    section: 'History',
                    light: {
                        fieldValue: darkWalletOverview.history.fieldValue,
                        fieldCss: '--wl-wallet-history-img',
                    },
                    dark: {
                        fieldValue: lightWalletOverview.history.fieldValue,
                        fieldCss: '--wl-wallet-history-img',
                    },
                    fieldKey: 'Image'
                }
            },
            message: {
                status: 1,
                sequence: 6,
                image: {
                    section: 'Message',
                    light: {
                        fieldValue: darkWalletOverview.message.fieldValue,
                        fieldCss: '--wl-wallet-message-img',
                    },
                    dark: {
                        fieldValue: lightWalletOverview.message.fieldValue,
                        fieldCss: '--wl-wallet-message-img',
                    },
                    fieldKey: 'Image'
                }
            },
        }

        return walletOverviewObj;
    }

    public getSidebar() {
        const sidebarObj = {
            home: {
                section: 'Home',
                sequence: 1,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            deposit: {
                section: 'Deposit',
                sequence: 2,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            withdraw: {
                section: 'Withdraw',
                sequence: 3,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            promotion: {
                section: 'Promotion',
                sequence: 5,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            tnc: {
                section: 'Tnc',
                sequence: 6,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            infocenter: {
                section: 'InfoCenter',
                sequence: 7,
                fieldValue: '',
                fieldCss: '',
                status: 1,
                fieldKey: 'MenuItem'
            },
            // logout: {
            //     section: 'Logout',
            //     sequence: 7,
            //     fieldValue: '',
            //     fieldCss: '',
            //     status: 1,
            //     fieldKey: 'MenuItem'
            // },
        }

        return sidebarObj;
    }

    public getNavigation() {
        const light = {
            game: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/game-light.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/game-light-active.png',
            },
            friend: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/friend-light.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/friend-light-active.png',
            },
            myaccount: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/myaccount-light.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/myaccount-light-active.png',
            },
            promotion: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/promotion-light.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/promotion-light-active.png',
            },
            livechat: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/livechat-light.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/livechat-light-active.png',
            },
        };
        const dark = {
            game: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/game-dark.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/game-dark-active.png',
            },
            friend: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/friend-dark.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/friend-dark-active.png',
            },
            myaccount: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/myaccount-dark.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/myaccount-dark-active.png',
            },
            promotion: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/promotion-dark.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/promotion-dark-active.png',
            },
            livechat: {
                fieldValue: this.imageUrlPrefix + '/bottom-nav/livechat-dark.png',
                fieldValue2: this.imageUrlPrefix + '/bottom-nav/livechat-dark-active.png',
            },
        };

        const bottomNavObj = {
            game: {
                section: 'Game',
                sequence: 1,
                light: {
                    fieldValue: light.game.fieldValue,
                    fieldCss: '--wl-bottom-nav-game',
                    fieldValue2: light.game.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-game-active',
                },
                dark: {
                    fieldValue: dark.game.fieldValue,
                    fieldCss: '--wl-bottom-nav-game',
                    fieldValue2: dark.game.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-game-active',
                },
                fieldKey: 'Image',
                status: 1
            },
            friend: {
                section: 'Friend',
                sequence: 2,
                light: {
                    fieldValue: light.friend.fieldValue,
                    fieldCss: '--wl-bottom-nav-friend',
                    fieldValue2: light.friend.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-friend-active',
                },
                dark: {
                    fieldValue: dark.friend.fieldValue,
                    fieldCss: '--wl-bottom-nav-friend',
                    fieldValue2: dark.friend.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-friend-active',
                },
                fieldKey: 'Image',
                status: 1
            },
            myaccount: {
                section: 'MyAccount',
                sequence: 3,
                light: {
                    fieldValue: light.myaccount.fieldValue,
                    fieldCss: '--wl-bottom-nav-myaccount',
                    fieldValue2: light.myaccount.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-myaccount-active',
                },
                dark: {
                    fieldValue: dark.myaccount.fieldValue,
                    fieldCss: '--wl-bottom-nav-myaccount',
                    fieldValue2: dark.myaccount.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-myaccount-active',
                },
                fieldKey: 'Image',
                status: 1
            },
            promotion: {
                section: 'Promotion',
                sequence: 4,
                light: {
                    fieldValue: light.promotion.fieldValue,
                    fieldCss: '--wl-bottom-nav-promotion',
                    fieldValue2: light.promotion.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-promotion-active',
                },
                dark: {
                    fieldValue: dark.promotion.fieldValue,
                    fieldCss: '--wl-bottom-nav-promotion',
                    fieldValue2: dark.promotion.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-promotion-active',
                },
                fieldKey: 'Image',
                status: 1
            },
            livechat: {
                section: 'LiveChat',
                sequence: 5,
                light: {
                    fieldValue: light.livechat.fieldValue,
                    fieldCss: '--wl-bottom-nav-livechat',
                    fieldValue2: light.livechat.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-livechat-active',
                },
                dark: {
                    fieldValue: dark.livechat.fieldValue,
                    fieldCss: '--wl-bottom-nav-livechat',
                    fieldValue2: dark.livechat.fieldValue2,
                    fieldCss2: '--wl-bottom-nav-livechat-active',
                },
                fieldKey: 'Image',
                status: 1
            },
        }

        return bottomNavObj;
    }

    generateCSS(detailList: ContentUnMemberSettingDetail[]): string {
        const lightTheme: string[] = [];
        const darkTheme: string[] = [];

        const cssList: string[] = [
            '--wl-color-1',
            '--wl-color-2',
            '--wl-color-3',
            '--wl-color-4',
            '--wl-color-5',
            '--wl-header-logo',
            '--wl-sidebar-logo',
            // '--wl-footer-certificate-img',
            // '--wl-footer-gaming-license-img',
            // '--wl-footer-security-img',
            // '--wl-footer-legal-disclaimer-img',
            // '--wl-wallet-deposit-img',
            // '--wl-wallet-withdraw-img',
            // '--wl-wallet-restore-img',
            // '--wl-wallet-history-img',
            // '--wl-wallet-message-img',
            // '--wl-game-tab-live',
            // '--wl-game-tab-live-active',
            // '--wl-game-tab-slot',
            // '--wl-game-tab-slot-active',
            // '--wl-game-tab-sport',
            // '--wl-game-tab-sport-active',
            // '--wl-game-tab-esport',
            // '--wl-game-tab-esport-active',
            // '--wl-game-tab-lotto',
            // '--wl-game-tab-lotto-active',
            // '--wl-game-tab-other',
            // '--wl-game-tab-other-active',
            // '--wl-bottom-nav-game',
            // '--wl-bottom-nav-game-active',
            // '--wl-bottom-nav-friend',
            // '--wl-bottom-nav-friend-active',
            // '--wl-bottom-nav-myaccount',
            // '--wl-bottom-nav-myaccount-active',
            // '--wl-bottom-nav-promotion',
            // '--wl-bottom-nav-promotion-active',
            // '--wl-bottom-nav-livechat',
            // '--wl-bottom-nav-livechat-active',
        ];

        const formatValue = (val: string): string => {
            if (!val?.trim()) return '';
            return val.startsWith('http://') || val.startsWith('https://')
                ? `url("${val}")`
                : val;
        };

        // Default values for Light theme
        const defaultLight: { [key: string]: string } = {
            '--wl-color-1': '#75e8f0',
            '--wl-color-2': '#404041',
            '--wl-color-3': '#b1b3b5',
            '--wl-color-4': '#5e5e5e',
            '--wl-color-5': '#ffffff',
            '--wl-game-tab-live': 'url("")',
            '--wl-game-tab-live-active': 'url("")',
            '--wl-game-tab-slot': 'url("")',
            '--wl-game-tab-slot-active': 'url("")',
            '--wl-game-tab-sport': 'url("")',
            '--wl-game-tab-sport-active': 'url("")',
            '--wl-game-tab-esport': 'url("")',
            '--wl-game-tab-esport-active': 'url("")',
            '--wl-game-tab-lotto': 'url("")',
            '--wl-game-tab-lotto-active': 'url("")',
            '--wl-game-tab-other': 'url("")',
            '--wl-game-tab-other-active': 'url("")',
            '--wl-header-logo': 'url("")',
            '--wl-sidebar-logo': 'url("")',
            '--wl-footer-legal-disclaimer-img': 'url("")',
            '--wl-footer-certificate-img': 'url("")',
            '--wl-footer-gaming-license-img': 'url("")',
            '--wl-footer-security-img': 'url("")',
            '--wl-wallet-deposit-img': 'url("")',
            '--wl-wallet-withdraw-img': 'url("")',
            '--wl-wallet-restore-img': 'url("")',
            '--wl-wallet-history-img': 'url("")',
            '--wl-wallet-message-img': 'url("")',
            '--wl-bottom-nav-game': 'url("")',
            '--wl-bottom-nav-game-active': 'url("")',
            '--wl-bottom-nav-friend': 'url("")',
            '--wl-bottom-nav-friend-active': 'url("")',
            '--wl-bottom-nav-myaccount': 'url("")',
            '--wl-bottom-nav-myaccount-active': 'url("")',
            '--wl-bottom-nav-promotion': 'url("")',
            '--wl-bottom-nav-promotion-active': 'url("")',
            '--wl-bottom-nav-livechat': 'url("")',
            '--wl-bottom-nav-livechat-active': 'url("")',
        };

        // Default values for Dark theme
        const defaultDark: { [key: string]: string } = {
            '--wl-color-1': '#75e8f0',
            '--wl-color-2': '#404041',
            '--wl-color-3': '#b1b3b5',
            '--wl-color-4': '#ffffff',
            '--wl-color-5': '#212121',
            '--wl-game-tab-live': 'url("")',
            '--wl-game-tab-live-active': 'url("")',
            '--wl-game-tab-slot': 'url("")',
            '--wl-game-tab-slot-active': 'url("")',
            '--wl-game-tab-sport': 'url("")',
            '--wl-game-tab-sport-active': 'url("")',
            '--wl-game-tab-esport': 'url("")',
            '--wl-game-tab-esport-active': 'url("")',
            '--wl-game-tab-lotto': 'url("")',
            '--wl-game-tab-lotto-active': 'url("")',
            '--wl-game-tab-other': 'url("")',
            '--wl-game-tab-other-active': 'url("")',
            '--wl-header-logo': 'url("")',
            '--wl-sidebar-logo': 'url("")',
            '--wl-footer-legal-disclaimer-img': 'url("")',
            '--wl-footer-certificate-img': 'url("")',
            '--wl-footer-gaming-license-img': 'url("")',
            '--wl-wallet-deposit-img': 'url("")',
            '--wl-wallet-withdraw-img': 'url("")',
            '--wl-wallet-restore-img': 'url("")',
            '--wl-wallet-history-img': 'url("")',
            '--wl-wallet-message-img': 'url("")',
            '--wl-bottom-nav-game': 'url("")',
            '--wl-bottom-nav-game-active': 'url("")',
            '--wl-bottom-nav-friend': 'url("")',
            '--wl-bottom-nav-friend-active': 'url("")',
            '--wl-bottom-nav-myaccount': 'url("")',
            '--wl-bottom-nav-myaccount-active': 'url("")',
            '--wl-bottom-nav-promotion': 'url("")',
            '--wl-bottom-nav-promotion-active': 'url("")',
            '--wl-bottom-nav-livechat': 'url("")',
            '--wl-bottom-nav-livechat-active': 'url("")',
        };

        const lightMap = new Map<string, string>();
        const darkMap = new Map<string, string>();

        // Extract from detailList
        detailList.forEach((detail) => {
            if (detail.status !== 1 || detail.isDeleted) return;

            detail.contentUnMemberSettingDetailSubList.forEach((sub) => {
                if (sub.isDeleted || !sub.fieldCss || !sub.fieldValue) return;

                const formatted = formatValue(sub.fieldValue);
                if (sub.themeMode === 'Dark') {
                    darkMap.set(sub.fieldCss, formatted);
                } else if (sub.themeMode === 'Light') {
                    lightMap.set(sub.fieldCss, formatted);
                }
            });
        });


        // Ensure all cssList items are included
        cssList.forEach(cssVar => {
            const lightVal = lightMap.get(cssVar) ?? defaultLight[cssVar] ?? '';
            const darkVal = darkMap.get(cssVar) ?? defaultDark[cssVar] ?? '';

            lightTheme.push(`${cssVar}: ${lightVal};`);
            darkTheme.push(`${cssVar}: ${darkVal};`);
        });

        const lightBlock = `.app.light {\n  ${lightTheme.join('\n  ')}\n}`;
        const darkBlock = `.app.dark {\n  ${darkTheme.join('\n  ')}\n}`;

        return `${lightBlock}\n\n${darkBlock}`;
    }
}
